import UserAvatar from "@/components/shared/UserAvatar";

type Props = {
  sender: string;
  avatarId: string;
};

export default function MessageAvatar({ sender, avatarId }: Props) {
  return (
    <UserAvatar
      username={sender}
      fallbackAttachmentId={avatarId}
      className="mb-auto size-8 text-xs"
    />
  );
}
